module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Oops,<br><span class=\\"color-red\\">it\u0027s cold here.</span>","description":"Error {code}","back":"Back to home"},"fr":{"title":"Oups, <br><span class=\\"color-red\\">Il fait froid par ici.</span>","description":"Erreur {code}","back":"Revenir à l\u0027accueil"}}')
  delete Component.options._Ctor
}
